import { ItemScheme } from '../../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../../Enums/MagicField.enum';

export const caseTypeOrganizationUnitDefaultScheme = (
	isOnlyOneRoot: boolean,
	organizationUnitId?: string,
): ItemScheme[] => {
	return [
		{
			type: MagicField.ORGANIZATION_UNIT_SELECT,
			key: 'parentCaseTypeId',
			title: 'component.caseType.higherManagementUnit',
			settings: {
				portal: true,
				hidden: isOnlyOneRoot,
				excludedIds: [organizationUnitId],
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'label',
			title: 'component.caseType.enterNameOfManagementUnit',
			settings: {
				required: true,
				errorMessage: 'validation.caseTypeOrganizationUnit.label',
			},
		},
	];
};
